import { Button, Table, Tooltip, message, Space } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ProblemasTableFormFilter } from "./problemas-table-form-filter";
import { TableCustom } from "../../../components/table";
import { ParagraphPopup } from "../../../components/paragraphPopup";
import { UnorderedListOutlined } from "@ant-design/icons";
import { status, status_actions, status_actions_text, status_text } from "../../../utils/pda-status";
import { storageSet } from "../../../services/storage";
import dayjs from "dayjs";
import http from "../../../services/http";
import { useNavigate, useSearchParams } from "react-router-dom";

const columns_actions = [
  {
    title: "Ação (Como?)",
    dataIndex: "descricao",
    className: "fontSmall",
    width: 500,
    render: (_, e) => <ParagraphPopup text={e?.descricao} title="Ação (Como?)" />,
  },
  {
    title: "Responsável (Quem?)",
    dataIndex: "colaborador",
    className: "fontSmall",
  },
  {
    title: "Início",
    dataIndex: "data_inicio",
    className: "fontSmall",
    width: 50,
    render: (_, e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
    renderText: (e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
  },
  {
    title: "Fim",
    dataIndex: "data_fim",
    className: "fontSmall",
    width: 50,
    render: (_, e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
    renderText: (e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "fontSmall",
    width: 50,
    render: (_, e) => status_actions[e?.status],
    renderText: (e) => status_actions_text[e?.status],
  },
];

const columns = [
  {
    title: "Nº",
    dataIndex: "id",
    width: 50,
    className: "fontSmall",
  },
  {
    title: "Filial/Setor/Colab. (Onde?)",
    dataIndex: "setor",
    className: "fontSmall",
    render: (_, e) => e?.setor ?? e?.responsavel,
    renderText: (e) => e?.setor ?? e?.responsavel,
  },
  {
    title: "Apontamento (O que?)",
    dataIndex: "oque",
    className: "fontSmall",
    width: 300,
    render: (_, e) => <ParagraphPopup text={e?.oque} title="Apontamento (O que?)" />,
  },
  {
    title: "Motivo (Por quê?)",
    className: "fontSmall",
    dataIndex: "porque",
    width: 300,
    render: (_, e) => <ParagraphPopup text={e?.porque} title="Motivo (Por quê?)" />,
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "fontSmall",
    render: (_, e) => status[e.status],
    renderText: (e) => status_text[e?.status],
  },
];

const ProblemasRelatorioTable = () => {
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const modo_visualizacao = searchParams.get("modo_visualizacao_r") ?? 1;

  const [acoes, setAcoes] = useState([]);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    filterRef.current?.submitForm();
  }, []);

  const listarProblemas = async (filtro) => {
    filtro.data_inicio = dayjs(filtro?.data_inicio).format("YYYY-MM-DD");
    filtro.data_fim = dayjs(filtro?.data_fim).format("YYYY-MM-DD");
    setLoading(true);
    const api = await http(
      "get",
      `v1/problemas/listar_relatorio?id_sistemas_origens=${filtro?.id_sistemas_origens}&status=${filtro?.status}&data_inicio=${filtro?.data_inicio}&data_fim=${filtro?.data_fim}&status_acoes=${filtro?.status_acoes}`,
      []
    );

    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      setDados(response);
      let array_acoes = [];
      for (const el of response) {
        array_acoes = [...array_acoes, ...el?.acoes];
      }
      setAcoes(array_acoes);
    } else {
      message.error(api.response.message);
    }
    storageSet("f_rpda", JSON.stringify(filtro));
    setLoading(false);
  };

  return (
    <>
      <ProblemasTableFormFilter
        name="modo_visualizacao_r"
        ref={filterRef}
        onFinish={listarProblemas}
        loading={loading}
      />
      <br />
      {Number(modo_visualizacao) === 1 && (
        <TableCustom
          loading={loading}
          columns={[
            ...columns,
            ...[
              {
                title: "Ações",
                dataIndex: "acoes",
                sorter: false,
                width: 80,
                render: (_, e) => (
                  <Space.Compact>
                    <Tooltip title="Detalhes">
                      <Button
                        onClick={() => navigate(`/planos-acao/relatorio/detalhes/${e.id}`)}
                        icon={<UnorderedListOutlined />}
                      />
                    </Tooltip>
                  </Space.Compact>
                ),
              },
            ],
          ]}
          dataSource={dados}
          expandable={{
            expandedRowRender: (data_children) => renderActions(data_children),
            expandIcon: ({ expanded, onExpand, record }) => (
              <Button type={expanded ? "primary" : "default"} onClick={(e) => onExpand(record, e)}>
                Ações ({record.acoes.length})
              </Button>
            ),
          }}
        />
      )}

      {Number(modo_visualizacao) === 2 && (
        <TableCustom
          rowClassName={(e) => (dayjs(e?.data_fim) < dayjs() && [-1, 2, 3].includes(e?.status) ? "danger" : "")}
          loading={loading}
          columns={[
            ...[
              {
                title: "Nº",
                dataIndex: "id_problemas",
              },
            ],
            ...columns_actions,
            ...[
              {
                title: "Ações",
                dataIndex: "actions",
                sorter: false,
                width: 50,
                render: (_, e) => (
                  <Tooltip title="Detalhes">
                    <Button
                      loading={loading}
                      onClick={() => navigate(`/planos-acao/relatorio/detalhes/${e.id_problemas}`)}
                      icon={<UnorderedListOutlined />}
                    />
                  </Tooltip>
                ),
              },
            ],
          ]}
          dataSource={acoes}
        />
      )}
    </>
  );
};

const renderActions = (acoes) => (
  <Table columns={columns_actions} dataSource={acoes.acoes} pagination={false} bordered size="small" rowKey="id" />
);

export { ProblemasRelatorioTable };
